import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col justify-center gap-4" }
const _hoisted_2 = { class: "flex flex-col place-items-center overflow-hidden" }
const _hoisted_3 = ["src"]

import BaseCard from '@/features/global/BaseCard.vue';
import PovoPrototype from '@/assets/Projects/PovoPhotos/PovoPrototype.jpg';
import { useImageViewer } from '@/features/composables/useImageViewer';


export default /*@__PURE__*/_defineComponent({
  __name: 'PovoProject',
  setup(__props) {

const { openImageMenu } = useImageViewer();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseCard, {
    title: 'POVO Class Registration Interface',
    highlightLastWord: false
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "w-full grid lg:grid-cols-2 lg:gap-20" }, [
          _createElementVNode("h5", { class: "lg:justify-self-end lg:pr-6 font-medium" }, "Project Leader"),
          _createElementVNode("h5", { class: "lg:justify-self-start lg:pl-6 font-medium" }, "January 2025 - January 2026")
        ], -1)),
        _cache[2] || (_cache[2] = _createElementVNode("p", { class: "text-center items-center px-4 gap-2" }, [
          _createElementVNode("span", { class: "block" }, "Revamped Notre Dame's PATH & NOVO class registration systems into one combined interface"),
          _createElementVNode("span", { class: "block" }, "Developed through 4 sprints of user research, sketches/prototypes, Figma design, & Vue.js reactive prototype"),
          _createElementVNode("span", { class: "block" }, "Led a team of 3 focused on HCI Principles"),
          _createElementVNode("span", { class: "block" }, "Collaborated with PhD Students & HCI faculty to engage with the ND Registrar"),
          _createElementVNode("span", { class: "block" }, [
            _createTextVNode("Visit the "),
            _createElementVNode("a", {
              href: "https://povo-interface-online.web.app/",
              target: "_blank",
              class: "link-in-text"
            }, "prototype"),
            _createTextVNode(" or read our "),
            _createElementVNode("a", {
              href: "https://docs.google.com/document/d/1FWvtfMxiwoWXePhVTn7zi39D3eHltyPQMtqWOpfCSvA/edit?usp=sharing",
              target: "_blank",
              class: "link-in-text"
            }, "Design Document"),
            _createTextVNode(" for more details! ")
          ])
        ], -1)),
        _createElementVNode("span", _hoisted_2, [
          _createElementVNode("img", {
            class: "w-[50%] h-auto rounded-lg cursor-pointer",
            src: _unref(PovoPrototype),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(openImageMenu)(_unref(PovoPrototype), 'POVO Interface', $event.currentTarget)))
          }, null, 8, _hoisted_3)
        ])
      ])
    ]),
    _: 1
  }))
}
}

})